export default "__VITE_ASSET__CgY$jDPQ__"